// Define a type for objects that have HATEOAS links
import { useClient } from "./client";
import * as types from "./gen/types.gen";
import { RequestOptionsBase } from "@hey-api/client-fetch";

type WithLinks = {
    links?: Record<string, types.Hateoas>;
};

type RequestOptions = Omit<RequestOptionsBase<false>, "method"> &
    Pick<Required<RequestOptionsBase<false>>, "method">;

function mergeSearchParams(href: string, searchParams?: URLSearchParams) {
    const url = new URL(new Request(href).url);
    return new URLSearchParams({
        ...Object.fromEntries(url.searchParams),
        ...Object.fromEntries(searchParams || new URLSearchParams()),
    });
}

export async function followLink<ExpectedData>(
    object: WithLinks,
    key: string,
    body?:
        | RequestInit["body"]
        | Record<string, unknown>
        | Array<Record<string, unknown>>
        | Array<unknown>
        | number,
    signal?: AbortSignal,
    query?: URLSearchParams
) {
    const link = object.links?.[key];
    if (!link) {
        throw new Error(`Link with key '${key}' not found`);
    }

    const baseUrl = import.meta.env.VITE_API_URL;
    const url = new URL(link.href, baseUrl);
    url.search = mergeSearchParams(link.href, query).toString();
    // Get relative URL
    const href = url.toString().replace(new RegExp("^" + baseUrl), "");

    const options: RequestOptions = {
        url: href,
        ...signal,
        method: (link.type as RequestOptions["method"]) || "GET",
    };

    if (body) {
        options.body = body;
    }

    const client = useClient({
        requires: {
            auth: true,
            organization: true,
            stek: true,
        },
    });

    return await client.request<ExpectedData>(options);
}
